import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [LIST_COMMENTS, LIST_COMMENTS_SUCCESS, LIST_COMMENTS_FAILURE] =
  createRequestActionTypes('chance/LIST_COMMENTS');

export const listComments = createAction(LIST_COMMENTS, (id) => id);
const listCommentsSaga = createRequestSaga(
  LIST_COMMENTS,
  chanceApi.getComments,
);

const UNLOAD_COMMENTS = 'chance/UNLOAD_COMMENTS';
export const unloadComments = createAction(UNLOAD_COMMENTS);

export function* chanceCommentsSaga() {
  yield takeLatest(LIST_COMMENTS, listCommentsSaga);
}

const initialState = {
  comments: null,
  error: null,
};

const chanceComments = handleActions(
  {
    [LIST_COMMENTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      comments: data.list.map((com) => ({
        id: com.brdUuid,
        brdUuid: com.brdUuid,
        prjUuid: com.prjUuid,
        boUuid: com.boUuid,
        parentBrdUuid: com.parentBrdUuid,
        brdTxt: com.brdTxt,
        useYn: com.useYn,
        crtUsr: com.crtUsr,
        profileImg: com.profileImg,
        crtNm: com.crtNm,
        crtDt: com.crtDt,
      })),
      error: null,
    }),
    [LIST_COMMENTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_COMMENTS]: () => initialState,
  },
  initialState,
);

export default chanceComments;
